export default {"width":961,"height":868};